<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">
        {{ (sicText['tramite-sic-comp-desleal'][tituloKey]) + nombreCompleto }}
      </h2>
    </div>
  </div>
  <div class="container-example-linea-avance-govco mx-0 my-5">
    <div
      class="linea-avance-govco ih-linea-avance-govco m-0 p-0"
      id="AvanceCompetencia">
      <div class="px-5">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 15%"
            aria-valuenow="15"
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
        <div class="items-header-linea-avance-govco">
          <div class="header-linea-avance-govco active-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#paso_1"
              percentage="20"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Paso 1: Solicitud de Asunto">
              <span>1</span>
            </button>
            <span class="title-linea-avance-govco">
              {{
                sicText['tramite-sic-comp-desleal']['solicitud-asunto']
              }}</span
            >
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#paso_2"
              percentage="40"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Paso 2: Agregar Demandante">
              <span>2</span>
            </button>
            <span class="title-linea-avance-govco">
              {{
                sicText['tramite-sic-comp-desleal']['agregar-demandante']
              }}</span
            >
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#paso_3"
              percentage="60"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Paso 3: Apoderado">
              <span>3</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ sicText['tramite-sic-comp-desleal']['apoderado'] }}</span
            >
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#paso_4"
              percentage="80"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Paso 4: Agregar Demandado">
              <span>4</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ sicText['tramite-sic-comp-desleal']['datos-demandado'] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#paso_5"
              percentage="100"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Paso 5: Documentos">
              <span>5</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ sicText['tramite-sic-comp-desleal']['documentos'] }}</span
            >
          </div>
        </div>
      </div>
      <div
        id="paso_1"
        class="body-linea-avance-govco active-linea-avance-govco"
        data-la-parent="#AvanceCompetencia">
        <app-recuadro-justino></app-recuadro-justino>
        <div class="contents-linea-avance-govco">
          <!-- Contenido Item -->
          <div class="contents-example-linea-avance-govco"></div>
          <div class="contents-example-linea-avance-govco">
            <!-- 📌 Contenido item 1 -->
            <app-form
              [title]="
                sicText['tramite-sic-comp-desleal']['clase-solicitud-asunto']
              "
              [fields]="formClaseSolicitud"
              [withSubmitButton]="false"
              (changeAction)="onChangeClaseSolicitud($event)"
              [idEntidad]="entidadId"></app-form>
            <!-- 🔚 End contenido item 1 -->
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button"
                  class="btn-govco fill-btn-govco btn-form w-auto"
                  (click)="submitForm(false, true)"
                  [attr.aria-label]="sicText['botones-envio']['guardar-sin-enviar']">
                  {{ sicText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinuePaso1(formGroupClaseSolicitud, $event)"
                  [attr.aria-label]="sicText['botones-envio']['continuar']">
                  {{ sicText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="paso_2"
        class="body-linea-avance-govco"
        data-la-parent="#AvanceCompetencia">
        <div class="contents-linea-avance-govco">
          <!-- Contenido Item -->
          <div class="contents-example-linea-avance-govco">
            <!-- 📌 Contenido item 2 -->
            <!-- 🧾 Tab demandante  -->
            <div class="tab__demandante">
              <!-- Tabs para Demandantes -->
              <ul
                class="nav nav-pills mb-3"
                id="demandantesTabs"
                role="tablist">
                <li
                  class="nav-item order-2 order-sm-1"
                  *ngFor="
                    let demandante of DemandanteArray.controls;
                    let i = index
                  "
                  role="presentation">
                  <button
                    class="btn-govco outline-btn-govco me-2 mb-2 mb-sm-0"
                    [ngClass]="{ active: i === activeTabIndexDemandantes }"
                    [id]="'demandante-tab-' + i"
                    (click)="setActiveTabDemandantes(i)"
                    data-bs-toggle="pill"
                    [attr.data-bs-target]="'#demandante-' + i"
                    type="button"
                    role="tab"
                    aria-controls="'demandante-' + i"
                    [attr.aria-selected]="i === 0 ? true : false"
                    [attr.aria-label]="sicText['tramite-sic-comp-desleal']['demandante'] + ' ' + (i + 1)">
                    {{ sicText['tramite-sic-comp-desleal']['demandante'] }}
                    {{ i + 1 }}
                  </button>
                </li>
                <button
                  class="btn-govco fill-add-govco order-1 order-sm-2 mb-2 mb-sm-0"
                  (click)="addDemandanteForm()"
                  [disabled]="deshabilitarAddDemandante"
                  [attr.aria-label]="sicText['tramite-sic-comp-desleal']['agregar-demandante']">
                  {{
                    sicText['tramite-sic-comp-desleal']['agregar-demandante']
                  }}
                </button>
              </ul>

              <div class="tab-content" id="demandantesTabsContent">
                <div
                  class="tab-pane fade"
                  *ngFor="
                    let demandante of DemandanteArray.controls;
                    let i = index
                  "
                  [ngClass]="{
                    show: i === activeTabIndexDemandantes,
                    active: i === activeTabIndexDemandantes,
                  }"
                  [id]="'demandante-' + i"
                  role="tabpanel"
                  [attr.aria-labelledby]="'demandante-tab-' + i">
                  <app-form
                    #DemandanteComponent
                    [title]="
                      sicText['tramite-sic-comp-desleal']['datos-demandante'] +
                      ' ' +
                      (i + 1)
                    "
                    [fields]="formDemandante[i]"
                    [withSubmitButton]="true"
                    (changedControl)="onChangeDemandante($event, i)"
                    (changeAction)="onChangeTipoDemandante($event, i)"
                    [sumbitButtonText]="
                      demandantes[i] != undefined
                        ? sicText['tramite-sic-comp-desleal'][
                            'actualizar-demandante'
                          ]
                        : sicText['tramite-sic-comp-desleal'][
                            'guardar-demandante'
                          ]
                    "
                    [alwaysEnableSubmit]="true"
                    (submitAction)="guardarDemandanteArray($event, i, false)"
                    [idEntidad]="entidadId">
                  </app-form>
                  <!-- Botón para eliminar demandante -->
                  <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3 mt-2">
                    <button
                      class="btn-govco fill-btn-danger-govco"
                      (click)="removeDemandanteForm(i, true, false)"
                      *ngIf="DemandanteArray.length > 1"
                      [attr.aria-label]="sicText['tramite-sic-comp-desleal']['eliminar-demandante']">
                      {{
                        sicText['tramite-sic-comp-desleal'][
                          'eliminar-demandante'
                        ]
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 🔚 End contenido item 2 -->
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button"
                  class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="sicText['botones-envio']['atras']">
                  {{ sicText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-btn-govco w-auto"
                  (click)="submitFormDemandante(0, true)"
                  [attr.aria-label]="sicText['botones-envio']['guardar-sin-enviar']"
                  >
                  {{ sicText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  *ngIf="demandantes.length > 0"
                  type="button"
                  class="btn-govco fill-next-btn-govco w-auto"
                  (click)="continuarDemandante($event)"
                  [attr.aria-label]="sicText['botones-envio']['continuar']">
                  {{ sicText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="paso_3"
        class="body-linea-avance-govco"
        data-la-parent="#AvanceCompetencia">
        <div class="contents-linea-avance-govco">
          <!-- Contenido Item -->
          <div class="contents-example-linea-avance-govco">
            <!-- 📌 Contenido item 3 -->
            <app-form
              [title]="sicText['tramite-sic-comp-desleal']['apoderado']"
              [fields]="formApoderado"
              [withSubmitButton]="false"
              (changedControl)="onChangeApoderado($event)"
              [idEntidad]="entidadId"></app-form>
            <!-- 🔚 End contenido item 3 -->
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button"
                  class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="sicText['botones-envio']['atras']">
                  {{ sicText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-btn-govco w-auto"
                  (click)="submitForm(false, true)"
                  [attr.aria-label]="sicText['botones-envio']['guardar-sin-enviar']"
                  >
                  {{ sicText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-next-btn-govco w-auto"
                  (click)="continuarAbogado($event)"
                  [attr.aria-label]="sicText['botones-envio']['continuar']">
                  {{ sicText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="paso_4"
        class="body-linea-avance-govco"
        data-la-parent="#AvanceCompetencia">
        <div class="contents-linea-avance-govco">
          <!-- Contenido Item -->
          <div class="contents-example-linea-avance-govco">
            <!-- 📌 Contenido item 4 -->
            <!-- 🧾 Tab demandado -->
            <div class="tab__demandado container">
              <!-- Tabs para Demandados -->
              <ul class="nav nav-pills mb-3" id="demandadosTabs" role="tablist">
                <li
                  class="nav-item order-2 order-sm-1"
                  *ngFor="
                    let demandado of DemandadoArray.controls;
                    let i = index
                  "
                  role="presentation">
                  <button
                    class="btn-govco outline-btn-govco me-2 mb-2 mb-sm-0"
                    [ngClass]="{ active: i === activeTabIndexDemandados }"
                    (click)="setActiveTabDemandandos(i)"
                    [id]="'demandado-tab-' + i"
                    data-bs-toggle="pill"
                    [attr.data-bs-target]="'#demandado-' + i"
                    type="button"
                    role="tab"
                    aria-controls="'demandado-' + i"
                    [attr.aria-selected]="i === 0 ? true : false"
                    [attr.aria-label]="sicText['tramite-sic-comp-desleal']['demandado'] + ' ' + (i + 1)">
                    {{ sicText['tramite-sic-comp-desleal']['demandado'] }}
                    {{ i + 1 }}
                  </button>
                </li>
                <button
                  class="btn-govco fill-add-govco order-1 order-sm-2 mb-2 mb-sm-0"
                  (click)="addDemandadoForm()"
                  [disabled]="deshabilitarAddDemandados"
                  [attr.aria-label]="sicText['tramite-sic-comp-desleal']['agregar-demandado']">
                  {{ sicText['tramite-sic-comp-desleal']['agegar-demandado'] }}
                </button>
              </ul>

              <div class="tab-content" id="demandadosTabsContent">
                <div
                  class="tab-pane fade"
                  *ngFor="
                    let demandado of DemandadoArray.controls;
                    let i = index
                  "
                  [ngClass]="{
                    show: i === activeTabIndexDemandados,
                    active: i === activeTabIndexDemandados,
                  }"
                  [id]="'demandado-' + i"
                  role="tabpanel"
                  [attr.aria-labelledby]="'demandado-tab-' + i">
                  <app-form
                    #DemandadoComponent
                    [title]="
                      sicText['tramite-sic-comp-desleal']['datos-demandado'] +
                      ' ' +
                      (i + 1)
                    "
                    [fields]="formDemandado[i]"
                    [dependsOnWithValueField]="'direccionDomicilio'"
                    (changeAction)="onChangeDemandado($event, i)"
                    [withSubmitButton]="true"
                    (changedControl)="onChangePersonaDemandado($event, i)"
                    [sumbitButtonText]="
                      demandados[i] != undefined
                        ? sicText['tramite-sic-comp-desleal'][
                            'actualizar-demandado'
                          ]
                        : sicText['tramite-sic-comp-desleal'][
                            'guardar-demandado'
                          ]
                    "
                    [alwaysEnableSubmit]="true"
                    (submitAction)="guardarDemandadoArray($event, i, false)"
                    [idEntidad]="entidadId"></app-form>
                  <!-- Botón para eliminar demandante -->
                  <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3 mt-2">
                    <button
                    class="btn-govco fill-btn-danger-govco"
                    (click)="removeDemandadoForm(i, true, false)"
                    *ngIf="DemandadoArray.length > 1"
                    [attr.aria-label]="sicText['tramite-sic-comp-desleal']['eliminar-demandado']">
                    {{sicText['tramite-sic-comp-desleal']['eliminar-demandado']}}
                  </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 🔚 End contenido item 4 -->

            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button"
                  class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="sicText['botones-envio']['atras']">
                  {{ sicText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-btn-govco w-auto"
                  (click)="submitFormDemandado(0, true)"
                  [attr.aria-label]="sicText['botones-envio']['guardar-sin-enviar']"
                  >
                  {{ sicText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  *ngIf="checkIfArrayNotEmpty()"
                  type="button"
                  class="btn-govco fill-next-btn-govco w-auto"
                  (click)="continuarDemandando($event)"
                  [attr.aria-label]="sicText['botones-envio']['continuar']">
                  {{ sicText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="paso_5"
        class="body-linea-avance-govco"
        data-la-parent="#AvanceCompetencia">
        <div class="contents-linea-avance-govco">
          <!-- Contenido Item -->
          <div class="contents-example-linea-avance-govco">
            <!-- 📌 Contenido item 5 -->
            <div class="mt-3" *ngIf="idTramiteObtentorCompentenciaDesleal">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ sicText['tramite-sic-comp-desleal']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="mostrarComponenteCarga"
                    [archivosPreCargados]="archivosPreCargados"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteObtentorCompentenciaDesleal"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviarEntidad"
                    [nombreCortoTramite]="nombreCortoLimpio"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="
                      validarArchivosCargados($event)
                    "></app-cargue-archivos-tramite>
                    <div class="mt-3 text-muted small d-flex align-items-center">
                      <i class="bi bi-info-circle me-2"></i>
                      {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
                    </div>
                </div>
              </div>

              <div class="mt-3 p-3 border bg-light" *ngIf="isNotEmptyObligatorio()">
                <div class="alert alert-info">
                  <p>
                    <strong>{{ 'confirmacion_envio.titulo' | translate }}</strong>
                    {{ 'confirmacion_envio.mensaje' | translate }}
                  </p>
                  <p class="fst-italic">
                    {{ 'confirmacion_envio.nota' | translate }}
                  </p>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="confirmacionEnvio"
                    [(ngModel)]="confirmacionEnvio"
                  />
                  <label class="form-check-label" for="confirmacionEnvio">
                    {{ 'confirmacion_envio.checkbox' | translate }}
                  </label>
                </div>
              </div>

              <div *ngIf="confirmacionEnvio" class="border p-4 mt-4 bg-white shadow-sm rounded">
                <h5 class="wrapper__form__title mb-0">
                  {{ 'copia_envio.desea_enviar_copia' | translate }}
                </h5>

                <p>
                  {{ 'copia_envio.descripcion' | translate:{ correo: correoDemandado, nombre: nombreDemandado } }}
                </p>

                <div class="d-flex gap-2 mt-3">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="rechazarEnvio()"
                    [attr.aria-label]="'copia_envio.rechazar' | translate">
                    {{ 'copia_envio.rechazar' | translate }}
                  </button>

                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="aceptarEnvio()"
                    [attr.aria-label]="'copia_envio.aceptar' | translate">
                    {{ 'copia_envio.aceptar' | translate }}
                  </button>
                </div>


              </div>

              <!-- 🔚 End contenido item 5 -->

              <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
                <div class="d-flex flex-column flex-md-row gap-2">
                  <button
                    type="button"
                    class="btn-govco fill-before-btn-govco mew-auto"
                    onclick="nextItemAdvanceLineIHorizonalBack(event)"
                    [attr.aria-label]="sicText['botones-envio']['atras']">
                    {{ sicText['botones-envio']['atras'] }}
                  </button>
                  <button
                    type="button"
                    class="btn-govco fill-btn-govco w-auto"
                    (click)="saveWithoutSending()"
                    [disabled]="(pesoTotalGB > valorMaximoGB)"
                    [attr.aria-label]="sicText['botones-envio']['guardar-sin-enviar']">
                    {{ sicText['botones-envio']['guardar-sin-enviar'] }}
                  </button>
                  <button
                    type="button"
                    class="btn-govco fill-send-govco w-auto"
                    (click)="finalizar()"
                    [attr.aria-label]="sicText['botones-envio']['enviar']">
                    {{ sicText['botones-envio']['enviar'] }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
